import { queryKeys, useHttpClient, useActiveOrganizationId } from '@repo/api-client/react';
import {
  StartStripeConnectResponseSchema,
  StripeConnectStatusSchema,
  type StripeConnectStatus,
} from '@repo/api-client/dtos';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getJSON, postJSON } from '../internal/http';

export function useStripeConnectStatus() {
  const http = useHttpClient();
  const orgId = useActiveOrganizationId();

  return useQuery({
    queryKey: orgId ? queryKeys.paymentProcessors.stripe(orgId) : ['payment-processors', 'idle'],
    queryFn: () =>
      getJSON(http, `/orgs/${orgId}/payments/stripe/status`, StripeConnectStatusSchema),
    enabled: Boolean(orgId),
  });
}

export function useStartStripeConnect() {
  const http = useHttpClient();
  const orgId = useActiveOrganizationId();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      postJSON(
        http,
        `/orgs/${orgId}/payments/stripe/connect`,
        {},
        StartStripeConnectResponseSchema,
      ),
    onSuccess: () => {
      if (orgId) {
        void queryClient.invalidateQueries({
          queryKey: queryKeys.paymentProcessors.stripe(orgId),
        });
      }
    },
  });
}

export function useDisconnectStripe() {
  const http = useHttpClient();
  const orgId = useActiveOrganizationId();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      postJSON(
        http,
        `/orgs/${orgId}/payments/stripe/disconnect`,
        {},
        StripeConnectStatusSchema,
      ),
    onSuccess: (data: StripeConnectStatus) => {
      if (orgId) {
        queryClient.setQueryData(queryKeys.paymentProcessors.stripe(orgId), data);
      }
    },
  });
}
